import { observable } from 'mobx';

export type CancelChargeOriginalMappingResponseArgs = {
  id?: number;
  cancel_charge_element_id?: number;
  cancel_charge_order_item_id?: number;
  cancel_charge_trace_id?: number;
  original_order_item_id?: number;
  original_trace_id?: number;
};

export type CancelChargeOriginalMappingArgs = {
  id?: number;
  cancelChargeElementId?: number;
  cancelChargeOrderItemId?: number;
  cancelChargeTraceId?: number;
  originalOrderItemId?: number;
  originalTraceId?: number;
};

export const convertCancelChargeOriginalMappingResponseToArgs = (
  response: CancelChargeOriginalMappingResponseArgs
): CancelChargeOriginalMappingArgs => {
  return {
    id: response.id,
    cancelChargeElementId: response.cancel_charge_element_id,
    cancelChargeOrderItemId: response.cancel_charge_order_item_id,
    cancelChargeTraceId: response.cancel_charge_trace_id,
    originalOrderItemId: response.original_order_item_id,
    originalTraceId: response.original_trace_id
  };
};

export default class CancelChargeOriginalMapping {
  @observable id?: number;
  @observable cancelChargeElementId?: number;
  @observable cancelChargeOrderItemId?: number;
  @observable cancelChargeTraceId?: number;
  @observable originalOrderItemId?: number;
  @observable originalTraceId?: number;

  constructor(args: CancelChargeOriginalMappingArgs = {}) {
    this.id = args.id;
    this.cancelChargeElementId = args.cancelChargeElementId;
    this.cancelChargeOrderItemId = args.cancelChargeOrderItemId;
    this.cancelChargeTraceId = args.cancelChargeTraceId;
    this.originalOrderItemId = args.originalOrderItemId;
    this.originalTraceId = args.originalTraceId;
  }

  get updateParams() {
    return {
      id: this.id,
      cancel_charge_element_id: this.cancelChargeElementId,
      cancel_charge_order_item_id: this.cancelChargeOrderItemId,
      cancel_charge_trace_id: this.cancelChargeTraceId,
      original_order_item_id: this.originalOrderItemId,
      original_trace_id: this.originalTraceId
    };
  }
}
